import blogFetch from "../axios/config";

// TTL em ms — janela curta o bastante para refletir mudanças, longa o bastante
// para absorver rajadas de eventos WebSocket que disparam várias requisições.
const TTL = 4000;

// resultados resolvidos: key -> { data, expiresAt }
const cache = new Map();

// requisições em voo: key -> Promise (dedup quando duas chamadas da mesma URL
// chegam antes da resposta da primeira).
const inFlight = new Map();

const buildKey = (status, furnace) => `${status}::${furnace}`;

/**
 * GET /ISAGA_VagoesFornos/hour/{status}?furnace={furnace} com cache TTL e dedup.
 * Retorna o objeto axios response (mesmo shape que blogFetch.get) para preservar
 * compatibilidade com chamadores que esperam `response.data`.
 */
export async function fetchHourByFurnaceCached(status, furnace) {
  const key = buildKey(status, furnace);
  const now = Date.now();

  const hit = cache.get(key);
  if (hit && hit.expiresAt > now) {
    return hit.response;
  }

  const pending = inFlight.get(key);
  if (pending) {
    return pending;
  }

  const promise = blogFetch
    .get(`/ISAGA_VagoesFornos/hour/${status}?furnace=${furnace}`)
    .then((response) => {
      cache.set(key, { response, expiresAt: Date.now() + TTL });
      return response;
    })
    .finally(() => {
      inFlight.delete(key);
    });

  inFlight.set(key, promise);
  return promise;
}

// Permite invalidar manualmente quando algo muda de forma confirmada
// (ex.: após um POST/PUT que sabidamente altera a fila do forno).
export function invalidateHourCache(status, furnace) {
  if (status && furnace) {
    cache.delete(buildKey(status, furnace));
    return;
  }
  cache.clear();
}
